export enum ChatMessageType {
    USER = 'user',
    BOT = 'bot',
}

export enum NotificationSource {
    NAVIGATION = 'NAVIGATION',
    IN_PAGE = 'IN-PAGE',
    BOTH = 'BOTH',
    NONE = 'NONE'
}

export interface Event {
    id: string;
    timestamp?: Date;
    description?: string;
    thumbnailUrl: string;
    videoUrl: string;
    /** Device ID needed for on-demand video transcoding via fetchEventVideo */
    deviceId?: string;
    /** Event start timestamp in ms, needed for video transcoding */
    startTimestampMs?: number;
    /** Event duration in ms, needed for video transcoding */
    durationMs?: number;
    /** Whether this is a blob URL that needs revoking on cleanup */
    isBlobUrl?: boolean;
    /** Whether this event still needs its video fetched (lazy loading) */
    needsFetch?: boolean;
    /** Whether this event is currently loading */
    isLoading?: boolean;
    /** Whether this event failed to load */
    hasError?: boolean;
}

export interface ChatMessage {
    type: ChatMessageType;
    content: string;
    timestamp: number;
    events?: Event[];
    reasoning?: string;
    isStreaming?: boolean;
    error?: string;
    responseTime?: number;
    totalTime?: number;
    llmModel?: string | null;
    vlmModel?: string | null;
}